import { Graphback } from '@gripp/shared-logic';
import { ColumnData, LoadingIndicator, SlideLayout } from '@gripp/shared-ui';
import { useLayoutEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { useResolveShareLink } from '../hooks/useShareIssue';
import { Issue } from './issue';

type ResolveShareLinkResponse = {
  share?: { resolveShareLink?: { subjectType: string; subjectId: string } };
};

// `/share/:token` — renders the issue view in place (URL stays on the link).
export const ShareView = () => {
  const { token } = useParams<{ token: string }>();

  // Set before descendant fetches so the first getIssue carries the header.
  useLayoutEffect(() => {
    Graphback.setShareToken(token ?? null);
    return () => Graphback.setShareToken(null);
  }, [token]);

  const { data, isLoading, isError } = useResolveShareLink(token) as {
    data?: ResolveShareLinkResponse;
    isLoading: boolean;
    isError: boolean;
  };
  const target = data?.share?.resolveShareLink;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isError || !token || !target || target.subjectType !== 'ISSUE') {
    return <Navigate to="/" replace />;
  }

  const column: ColumnData = {
    title: 'activities.detail.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: (
      <AssetRouteProvider
        value={{
          basePath: `/activities/${target.subjectId}`,
          listPath: '/activities',
          isWorkspaceMode: false,
          issueId: target.subjectId,
        }}
      >
        <Issue issueId={target.subjectId} isComingFromActivities />
      </AssetRouteProvider>
    ),
  };

  return <SlideLayout leftColumn={column} />;
};
